import React from "react";
import {useNavigate} from "react-router-dom";
import {ScanOutlined, EyeInvisibleOutlined, ThunderboltOutlined, DashboardOutlined, UndoOutlined} from "@ant-design/icons";
import {isAdmin} from "../util/anonymizerApi";

// admin: full configuration; agent: only the cockpit review workflow
const AREAS = [
    {label: "Cockpit", key: "cockpit", icon: <DashboardOutlined/>},
    {label: "Restore", key: "restore", icon: <UndoOutlined/>},
    {label: "Runs", key: "runs", icon: <ThunderboltOutlined/>, adminOnly: true},
    {label: "Anonymization Rules", key: "anonymizer", icon: <EyeInvisibleOutlined/>, adminOnly: true},
    {label: "PII Detection", key: "mltraining", icon: <ScanOutlined/>, adminOnly: true},
];

const BRAND = "#E4691A";

/**
 * Shared app header: dark bar with the top-level area navigation.
 * `extra` renders on the right side (e.g. Save actions).
 */
const AppHeader = ({area, extra}) => {
    const navigate = useNavigate();

    return (
        <div style={{
            display: "flex",
            alignItems: "center",
            gap: 28,
            padding: "0 32px",
            height: 56,
            background: "#1a1712",
            borderBottom: `2px solid ${BRAND}`,
            flexShrink: 0,
            color: "#fff",
        }}>
            <div style={{display: "flex", alignItems: "center", gap: 10, minWidth: 170}}>
                <img src="/manyoselement.png" height="24" alt="SMILEconceal"/>
                <span style={{fontSize: 16, fontWeight: 700, letterSpacing: 0.3}}>
                    SMILE<span style={{color: BRAND}}>conceal</span>
                </span>
            </div>
            <nav style={{display: "flex", gap: 6, flex: 1}}>
                {AREAS.filter((a) => !a.adminOnly || isAdmin()).map((a) => {
                    const active = a.key === area;
                    return (
                        <div
                            key={a.key}
                            onClick={() => navigate("/" + a.key)}
                            style={{
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                gap: 7,
                                padding: "7px 16px",
                                borderRadius: 999,
                                fontSize: 14,
                                fontWeight: active ? 600 : 400,
                                color: active ? "#fff" : "rgba(255,255,255,0.65)",
                                backgroundColor: active ? BRAND : "transparent",
                                boxShadow: active ? "0 2px 8px rgba(239,119,33,0.4)" : "none",
                                transition: "all 0.15s",
                            }}
                            onMouseEnter={(e) => {
                                if (!active) e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.08)";
                            }}
                            onMouseLeave={(e) => {
                                if (!active) e.currentTarget.style.backgroundColor = "transparent";
                            }}
                        >
                            <span style={{fontSize: 15, display: "inline-flex"}}>{a.icon}</span>
                            {a.label}
                        </div>
                    );
                })}
            </nav>
            {extra && <div style={{marginLeft: "auto", color: "#fff"}}>{extra}</div>}
        </div>
    );
};

export default AppHeader;
